var React = require('react');

function RequestSent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 0L0 6L5.65385 9.23077L12 5L7.76923 11.3462L11 17L17 0Z","fill":"black"}));
}

RequestSent.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = RequestSent;

RequestSent.default = RequestSent;
